import ApiService from "./ApiService";
import utilityService from "./utilityService";

const getAll = async () => {
  try {
    const url = "/GetAllCategories";
    const response = await ApiService.get(url);
    if (response && response.data) return response.data;
  } catch (err) {
    console.log("ApiError", err.message);
  }
  return [];
};

const getOne = async (id) => {
  try {
    const url = `/GetCategory?Id=${id}`;
    const response = await ApiService.get(url);
    if (response && response.data) return response.data;
  } catch (err) {
    console.log("ApiError", err.message);
  }
  return null;
};

const update = async (data) => {
  const url = "/UpdateCategory?" + utilityService.queryString(data);
  try {
    const result = await ApiService.post(url, data, {
      "Content-Type": "application/json",
    });
    if (result.status === 200)
      return {
        success: true,
        message: result.data,
      };
  } catch (err) {
    console.log("ApiError", err.message);
  }
  return {
    success: false,
    message: "Failed to update category",
  };
};

const add = async (data) => {
  const url = "/AddCategory?" + utilityService.queryString(data);

  try {
    const result = await ApiService.post(url, data, {
      "Content-Type": "application/json",
    });
    if (result.status === 200)
      return {
        success: true,
        message: result.data,
      };
  } catch (err) {
    console.log("ApiError", err.message);
  }
  return {
    success: false,
    message: "Failed to add new category",
  };
};

const remove = async (id) => {
  const url = "/DeleteCategory?Id=" + id;

  try {
    const result = await ApiService.post(url);
    if (result.status === 200)
      return {
        success: true,
        message: result.data,
      };
  } catch (err) {
    console.log("ApiError", err.message);
  }
  return {
    success: false,
    message: "Failed to remove category",
  };
};

export default {
  getAll,
  getOne,
  add,
  update,
  remove,
};
